import axios from 'axios';

import { API_LEGACY_CACHE_URL } from './consts';

const lagacyAgent = axios.create({
  baseURL: API_LEGACY_CACHE_URL,
  headers: {
    'content-type': 'application/json',
  },
});

lagacyAgent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      if (error?.config) {
        return axios.request({
          ...error.config,
        });
      }
    }

    return Promise.reject(error);
  },
);

export { lagacyAgent };
